module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/btn-portuguesse-download.58158345.png";